<div *ngIf="this.isLoading" class="progress-spinner">
	<p-progressSpinner></p-progressSpinner>
</div>

<div [hidden]="!this.isPrimary" id="mention_table">
	<div class="relative tyalls-table-name flex justify-content-between pr-3">

		<div (click)="backButton()" class="absolute back-tag-position cursor-pointer flex gap-2">
			<div [hidden]="!this.isPrimary" class="text-white schedule-tag-comments">
				<div class="flex text-white font-bold mr-2"> < Back</div>
			</div>
		</div>

		<div class="absolute date-tag-position flex gap-2">
			<div [hidden]="!this.isPrimary" class="text-white schedule-tag-comments">
				<div class="flex">
					<span class="dark-purple-text font-bold mr-2">Due: </span>
					<span data-cy="due-date">
					{{ this.currentTask.dueDate | DateLocalFormat: false }}
					</span>
				</div>
			</div>
		</div>

		<div class="hidden lg:block">
			<div *ngIf="!this.pdfPanelInFocus" class="w-1rem">
				<h6
					(click)="goToPreviousTask()"
					[hidden]="!this.currentTask.prevTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer ml-1"
				>
					<
				</h6>
			</div>

			<div *ngIf="this.pdfPanelInFocus" class="w-6rem mb-2">
				<h6
					(click)="goToPreviousTask()"
					[hidden]="!this.currentTask.prevTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer ml-1"
				>
					< <span>Previous</span>
				</h6>
			</div>
		</div>

		<div class="lg:hidden block">
			<div *ngIf="this.pdfPanelInFocus" class="w-1rem mb-2">
				<h6
					(click)="goToPreviousTask()"
					[hidden]="!this.currentTask.prevTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer ml-1 mr-2"
				>
					<
				</h6>
			</div>

			<div *ngIf="!this.pdfPanelInFocus" class="w-1rem mb-2">
				<h6
					(click)="goToPreviousTask()"
					[hidden]="!this.currentTask.prevTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer ml-1 mr-2"
				>
					<
				</h6>
			</div>
		</div>

		<!-- Task title -->


		<h6
			*ngIf="this.pdfPanelInFocus"
			[ngClass]="this.pdfPanelInFocus? 'tyalls-table-heading flex text-sm md:text-base mt-1 md: mt-0':'tyalls-table-heading text-sm mt-1'"
		>
			<span *ngIf="this.pdfPanelInFocus" class="opacity-60 hidden md:block mr-1">Task name: </span>
			{{ this.currentTask.name.trim() }} <span
			*ngIf="currentTask.type === WorkflowType.Form">&nbsp;-&nbsp;{{ this.currentTask.processId }}</span>
		</h6>

		<!-- Next button -->

		<div class="hidden lg:block">
			<div *ngIf="!this.pdfPanelInFocus" class="w-1rem mb-2">
				<h6
					data-cy="next-button"
					(click)="goToNextTask()"
					[hidden]="!this.currentTask.nextTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer text-right"
				>
					>
				</h6>
			</div>

			<div *ngIf="this.pdfPanelInFocus" class="w-6rem">
				<h6
					(click)="goToNextTask()"
					[hidden]="!this.currentTask.nextTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer text-right"
				>
					<span>Next</span> >
				</h6>
			</div>
		</div>

		<div class="lg:hidden block">
			<div *ngIf="this.pdfPanelInFocus" class="w-1rem mb-2">
				<h6
					(click)="goToNextTask()"
					[hidden]="!this.currentTask.nextTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer text-right"
				>
					>
				</h6>
			</div>

			<div *ngIf="!this.pdfPanelInFocus" class="w-1rem mb-2">
				<h6
					(click)="goToNextTask()"
					[hidden]="!this.currentTask.nextTask"
					class="tyalls-table-heading task-scroll-text cursor-pointer text-right"
				>
					>
				</h6>
			</div>
		</div>
	</div>
</div>

<!-- SPACER////////////////////////////////////////////////////////////////////// -->
<div
	*ngIf="this.currentFile?.type !== 4 && !this.isReviewable() && this.isPrimary"
	[class]="this.showPanelPadding"
></div>

<!-- REVIEW BUTTON ////////////////////////////////////////////////////////////// -->

<div *ngIf="this.isPrimary && this.hasFile">
	<div
		*ngIf="this.isReviewable()"
		[class]="this.showPanelPadding"
		class="flex justify-content-end pr-2 py-2"
	>
		<button
			data-cy="review-button"
			(click)="onReview()"
			[disabled]="isSubmitButtonDisabled()"
			class="p-button-raised w-fit"
			label="Review"
			pButton
			pRipple
			type="button"
		></button>
	</div>

	<!-- REVIEW & ASSIGN BUTTONS /////////////////////////////////////////////////// -->

	<div
		*ngIf="this.isReviewableForm()"
		[class]="this.flexCss"
		class="choose-button-padding"
	>
		<div class="mb-2">
			<app-group-drop-down
				(groupChange)="this.relayGroupChange($event)"
				label="Please Select a Group to Assign the Form to"
			></app-group-drop-down>
		</div>

		<div class="mb-2">
			<button
				(click)="this.onAssign($event)"
				[disabled]="isSubmitButtonDisabled()"
				class="p-button-raised"
				label="Review & Assign"
				pButton
				pRipple
				type="button"
			></button>
		</div>

		<div class="mb-2">
			<button
				(click)="this.onComplete($event)"
				[disabled]="isSubmitButtonDisabled()"
				class="p-button-raised"
				label="Review & Complete Task"
				pButton
				pRipple
				type="button"
			></button>
		</div>
	</div>
</div>
<!-- RESEND BUTTON ////////////////////////////////////////////////////////////////// -->

<div
	*ngIf="this.currentFile?.type === 4 && this.phobosTaskInstance.completedDate"
	class="flex justify-content-end choose-button-padding"
>
	<div class="flex gap-3 w-full justify-content-end">
		<button
			(click)="onReopen($event)"
			*ngIf="this.userPermissions?.forms?.admin"
			[disabled]="isSubmitButtonDisabled()"
			class="p-button-raised p-mr-2 p-mb-2 max-w-fit"
			label="Revert Task"
			pButton
			pRipple
			type="button"
		></button>

		<button
			(click)="onResend($event)"
			[disabled]="isSubmitButtonDisabled()"
			class="p-button-raised max-w-fit"
			label="Resend Completion Email"
			pButton
			pRipple
			type="button"
		></button>
	</div>
</div>

<div [hidden]="!this.hasFile" class="panel-height" id="{{ this.containerId }}"></div>

<div *ngIf="this.isPrimary && !this.hasFile">
	<app-upload-workflow-file
		(uploadAction)="this.uploadWorkflowFile()"
		[uploadedFiles]="this.uploadedFiles"
	></app-upload-workflow-file>
</div>
